import { useLayoutEffect, useEffect } from 'react'

/**
 * @name useIsomorphicLayoutEffect
 * @description Util for SSR and SSG to avoid layout effects, when the rendering ocurrs in the server, useEffect is used, when the rendering ocurrs in the browser, useLayoutEffect is used.
 * @param effect {function} Example: () => {}
 * @param dependencies {array} Example: [state]
 * @returns {void}
 */
const useIsomorphicLayoutEffect =
    typeof window !== 'undefined' ? useLayoutEffect : useEffect

export { useIsomorphicLayoutEffect }
